/**
 * Which product a reference list renders in.
 *
 * `evidence` is standalone Evidence and keeps today's row behavior. `work` is
 * the citations panel. Evidence is regulated, so its rendering only changes
 * through this switch.
 */
export type ReferenceSurface = 'evidence' | 'work';

export const DEFAULT_REFERENCE_SURFACE: ReferenceSurface = 'evidence';
